import ZonesTab from "@features/stock/components/ZonesTab";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/zones/")({
  component: ZonesTab,
});
